<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .bottom-row {
    display: flex;
    gap: utils.in_rem(12px);
    padding: utils.in_rem(18px) utils.in_rem(37px);
    @include colors.background-color(interfaceSwGrey_5);
  }
</style>

<script>
  import ApproveButton from "./ApproveButton.svelte";
  import CallDropdown from "./CallDropdown.svelte";
  import ConvertToEmailButton from "./ConvertToEmailButton.svelte";
  import ConvertToInMailButton from "./ConvertToInMailButton.svelte";
  import InterestedButton from "./InterestedButton.svelte";
  import LogCallDropdown from "./LogCallDropdown.svelte";
  import MarkAsDoneButton from "./MarkAsDoneButton.svelte";
  import NotInterestedButton from "./NotInterestedButton.svelte";
  import SendConnectionRequestButton from "./SendConnectionRequestButton.svelte";
  import SendInMailButton from "./SendInMailButton.svelte";
  import UseNewEmailButton from "./UseNewEmailButton.svelte";

  import { todosModalItemStore } from "../stores";

  let cls = "";
  export let clientHeight;
  export { cls as class };
</script>

<div class="{cls} bottom-row" bind:clientHeight>
  {#if $todosModalItemStore.kind === "generalTask"}
    <NotInterestedButton />
    <InterestedButton />
    <MarkAsDoneButton kind="primary" />
  {:else if $todosModalItemStore.kind === "sendEmailAfterInmail"}
    <NotInterestedButton />
    <InterestedButton />
    <ApproveButton />
  {:else if $todosModalItemStore.kind === "phoneCall"}
    <CallDropdown />
    <LogCallDropdown />
  {:else if $todosModalItemStore.kind === "linkedinConnectionRequest"}
    <MarkAsDoneButton kind="secondary" />
    <SendConnectionRequestButton />
  {:else if $todosModalItemStore.kind === "sendInmail"}
    <MarkAsDoneButton kind="secondary" />
    <ConvertToEmailButton />
    <SendInMailButton />
  {:else if $todosModalItemStore.kind === "bounce"}
    <ConvertToInMailButton />
    <UseNewEmailButton />
  {/if}
</div>
